/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Workout_Card_CtaInputs */

const en_us2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build a quick workout`)
};

const pt_br2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar treino rápido`)
};

const es_419_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armar entrenamiento rápido`)
};

const pt_pt2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montar treino rápido`)
};

const fr_fr2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une séance rapide`)
};

const de_de2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnelltraining erstellen`)
};

const it_it2_quick_workout_card_cta = /** @type {(inputs: Quick_Workout_Card_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea allenamento rapido`)
};

/**
* | output |
* | --- |
* | "Build a quick workout" |
*
* @param {Quick_Workout_Card_CtaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const quick_workout_card_cta = /** @type {((inputs?: Quick_Workout_Card_CtaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Workout_Card_CtaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_quick_workout_card_cta(inputs)
	if (locale === "es-419") return es_419_quick_workout_card_cta(inputs)
	if (locale === "pt-PT") return pt_pt2_quick_workout_card_cta(inputs)
	if (locale === "fr-FR") return fr_fr2_quick_workout_card_cta(inputs)
	if (locale === "de-DE") return de_de2_quick_workout_card_cta(inputs)
	if (locale === "it-IT") return it_it2_quick_workout_card_cta(inputs)
	return en_us2_quick_workout_card_cta(inputs)
});
export { quick_workout_card_cta as "quick-workout.card_cta" }